import React, { useCallback, useState } from "react";
import { DashboardLayoutProps } from "../common/types";
import DashboardNavbar from "./DashboardNavbar";
import Footer from "./Footer";
import { useTheme } from "../../context/ThemeContext";
import { Container } from "../ui/Containers";
import { styled } from "styled-components";
import { DashboardMenu } from "../ui/Icons";
import { useLocation } from "react-router-dom";
import TinyMenu from "../layouts/DashboardTinyMenu";

const CenterElemOnCondition = styled.div`
  .conditionallyCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  conditionCenter,
}) => {
  const { theme, toggleTheme } = useTheme();
  const isDarkMode = theme === "dark";
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);
  const location = useLocation();

  // Check where to not display menu and menu btn
  const PUBLIC_ROUTES = [
    "/dashboard/login",
    "/dashboard/register",
    "/dashboard/reset-password",
    "/dashboard/forgot-password",
  ];

  const INNER_ROUTES = ["/dashboard/landing/add-project", "/dashboard/landing/edit-project"]
  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);
  const isInnerRoute = INNER_ROUTES.includes(location.pathname);

  return (
    <>
      <DashboardNavbar toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
      <Container>
        <CenterElemOnCondition>
          {(!isPublicRoute && !isInnerRoute) && (
            <DashboardMenu toggleMenu={toggleMenu} isSideMenuOpen={menuOpen} />
          )}
          <div
            className={`App-col ${conditionCenter}`}
          >
            <div
              style={{
                marginTop: (!isPublicRoute && !isInnerRoute) ? "90px" : 0,
                width: "100%",
              }}
            >
              {children}
            </div>
          </div>
        </CenterElemOnCondition>
      </Container>
      <Footer />

      {menuOpen && (!isPublicRoute && !isInnerRoute) && (
        <TinyMenu
          open={menuOpen}
          onClose={toggleMenu}
          isDarkMode={isDarkMode}
        />
      )}
    </>
  );
};

export default DashboardLayout;
